
export const numbers = {
    int32MinValue: -2147483647,
    int32MaxValue: 2147483647,
    decimal184MinValue: -99999999999990,
    decimal184MaxValue: 99999999999990,
    decimal182MinValue: -9999999999999990,
    decimal182MaxValue: 9999999999999990,
};
